import React from "react";
import "../styles/CMF.css";

const CMF: React.FC = () => {
  const cmfData = [
    {
      name: "SHREE GANGA MHALASA ENTERPRISES",
      address:
        "NO. 271, OPP. GOVT. PRIMARY SCHOOL, Gamanagatti Road, Shivanand Nagar, Hubballi, Dharwad, Karnataka, 580025.",
    },
    {
      name: "MAKHAN CHOR",
      address:
        "GROUND,3C,RASHBEHARIAVENUE,KALIGHAT, Kalighat, Kolkata, Kolkata, West Bengal, 700026.",
    },
    {
      name: "M/S VIVEK ENTERPRISES",
      address:
        "H.NO-55, KITADIH NEW COLONY, PLOT NO-1167, KHATA NO-51, NEAR NEW POST OFFICE, KITADIH, JAMSHEDPUR, EAST SINGHBHUM, JHARKHAND - 831002",
    },
    {
      name: "ARABIAN DISTRIBUTOR",
      address:
        "Building No: 9/380, Ullanam North, Ullanam, Neduva, Malappuram, Kerala - 676303",
    },
    {
      name: "M/s. ARNAPURNA AGENCIES",
      address:
        "MAHANAPUR, MAHANAPUR, RAMESWAR, MAHANAPUR, Cuttack, Odisha, 754201.",
    },
  ];

  return (
    <section id="cmf" className="cmf">
      <div className="container">
        <h2>OUR C&F's</h2>
        <div className="cmf-grid">
          {cmfData.map((cmf, index) => (
            <div key={index} className="cmf-box">
              <h3>{cmf.name}</h3>
              <p>{cmf.address}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CMF;
